;(function () {
  function initSanHardwireReviews() {
    var sections = document.querySelectorAll('.san-hardwire-reviews-section');
    
    if (sections.length === 0) return;
    
    sections.forEach(function (section) {
      var wrapper = section.querySelector('.san-hardwire-reviews');
      if (!wrapper) return;
      
      var blockCount = parseInt(wrapper.getAttribute('data-block-count'), 10) || 0;
      var swiperEl = section.querySelector('.san-hardwire-reviews__swiper');
      var prevBtn = section.querySelector('.san-hardwire-reviews__nav--prev');
      var nextBtn = section.querySelector('.san-hardwire-reviews__nav--next');
      
      if (blockCount < 1 || !swiperEl) return;
      
      // Destroy existing swiper if reinitializing
      if (swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
      }
      
      // Initialize Swiper - standard slide effect, CSS handles the 3D look
      var swiper = new Swiper(swiperEl, {
        // Layout
        slidesPerView: 1.15,
        spaceBetween: 16,
        centeredSlides: true,
        
        // Behavior
        loop: blockCount >= 3,
        grabCursor: true,
        watchSlidesProgress: true,
        
        // Navigation arrows
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        
        // Responsive breakpoints
        breakpoints: {
          550: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          750: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 32,
          },
        },
        
        // Events
        on: {
          init: function () {
            wrapper.classList.add('swiper-initialized');
          },
        },
      });
    });
  }

  // Wait for Swiper to be available
  function waitForSwiper(callback, maxAttempts) {
    var attempts = 0;
    maxAttempts = maxAttempts || 50;
    
    function check() {
      attempts++;
      if (typeof Swiper !== 'undefined') {
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(check, 100);
      } else {
        console.warn('SAN HARDWIRE Reviews: Swiper not loaded after max attempts');
      }
    }
    check();
  }

  // Initialize when DOM is ready and Swiper is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForSwiper(initSanHardwireReviews);
    });
  } else {
    waitForSwiper(initSanHardwireReviews);
  }

  // Reinitialize on Shopify Theme Editor events
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('san-hardwire-reviews-section')) {
      waitForSwiper(initSanHardwireReviews);
    }
  });
})();